import { render, staticRenderFns } from "./ChangeRelated.vue?vue&type=template&id=652455e3"
import script from "./ChangeRelated.vue?vue&type=script&lang=js"
export * from "./ChangeRelated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports